<template>
  <nav role="navigation" class="diy-topbar__navbar">
    <!-- NOTIFICATIONS -->
    <button
      @click="toggleNavbarModal('TheTopbarNavbarAlerts')"
      :class="[alertMenuUnreadClass, alertMenuActiveClass]"
      class="diy-topbar__notifications-toggle"
    >
      <AppIcon :icon="alertsIcon" />
    </button>
    <!-- MENU TOGGLE -->
    <button
      @click="toggleNavbarModal('TheTopbarNavbarMenu')"
      :class="isMenuOpen && 'active'"
      class="diy-topbar__menu-toggle"
    >
      <AppIcon :icon="menuIcon" />
      <AppIcon icon="fas fa-sort-down" />
    </button>
    <!-- NAVBAR CONTENT -->
    <transition name="open-modal">
      <div v-if="isShown" class="diy-topbar__navbar-modal">
        <component
          :is="component"
          v-bind="componentProps"
          v-on-clickaway="toggleNavbarModal"
          @clicked="toggleNavbarModal"
        >
        </component>
        <!-- NAVBAR MENU -->
      </div>
    </transition>
  </nav>
</template>

<script>
// Utilities
import { EventBus } from '@/main'
import { mixin as clickaway } from 'vue-clickaway'
// Components
import AppIcon from 'Ui/AppIcon'
import TheTopbarNavbarMenu from './TheTopbarNavbarMenu'
import TheTopbarNavbarAlerts from './TheTopbarNavbarAlerts'

export default {
  name: 'TheTobarNavbar',

  components: {
    AppIcon,
    TheTopbarNavbarMenu,
    TheTopbarNavbarAlerts,
  },

  mixins: [clickaway],

  data() {
    return {
      isShown: false,
      component: '',
    }
  },

  methods: {
    toggleNavbarModal(component) {
      this.isShown ? this.closeNavbarModal() : this.openNavbarModal(component)
    },

    openNavbarModal(component) {
      this.isShown = true
      this.component = component
    },

    closeNavbarModal() {
      this.isShown = false
      this.component = ''
    },
  },

  computed: {
    componentProps() {
      if (this.component === 'TheTopbarNavbarMenu') return { items: this.menuItems }
      return false
    },

    userHasAlerts() {
      return this.$store.getters['alerts/userHasAlerts']
    },

    alertMenuActiveClass() {
      return this.isAlertsOpen && 'active'
    },

    alertMenuUnreadClass() {
      return this.userHasAlerts && 'unread'
    },

    isAlertsOpen() {
      return this.component === 'TheTopbarNavbarAlerts'
    },

    isMenuOpen() {
      return this.component === 'TheTopbarNavbarMenu'
    },

    menuIcon() {
      return this.isShown && this.isMenuOpen ? 'fas fa-user' : 'far fa-user'
    },

    alertsIcon() {
      return this.isAlertsOpen || this.userHasAlerts ? 'fas fa-bell' : 'far fa-bell'
    },
  },

  async created() {
    // first loading when loggin
    await this.$store.dispatch('alerts/load')
    // listening for closing navbar modal ( on click notification)
    EventBus.$on('close-topbar-modal', this.closeNavbarModal)
  },

  beforeDestroy() {
    EventBus.$off('close-topbar-modal', this.closeNavbarModal)
  },
}
</script>

<style scoped>
.diy-topbar__navbar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  gap: 10px;
}

.diy-topbar__navbar-modal {
  position: absolute;
  top: 58px;
  left: 100%;
  min-width: 300px;
  border-radius: 8px;
  border: 1px solid var(--c-secondary-400);
  box-shadow: 0 0 10px -3px var(--rgba-default);
  overflow: hidden;
  transform: translateX(-100%);
}

.diy-topbar__menu-toggle,
.diy-topbar__notifications-toggle {
  font-size: 1rem;
  color: var(--c-primary);
  background-color: #fff;
  transition: filter 300ms;
}

.diy-topbar__menu-toggle:hover,
.diy-topbar__notifications-toggle:hover {
  filter: brightness(0.92);
}

.diy-topbar__menu-toggle.active {
  color: var(--c-secondary-700);
}

.diy-topbar__notifications-toggle {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50px;
}

.diy-topbar__notifications-toggle.unread {
  background-color: var(--c-bright-red-500);
}

.diy-topbar__menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 3.75rem;
  height: 2.5rem;
  border-radius: 1.25rem;
}

.diy-topbar__menu-toggle .fa-sort-down {
  color: var(--c-secondary);
  margin-top: -5px;
}

.diy-topbar .diy-topbar__notifications-toggle.active > .app-icon {
  color: var(--c-bright-red-500);
}

.diy-topbar .diy-topbar__notifications-toggle.unread > .app-icon {
  color: #fff;
}

/* navbar modal transition */
.open-modal-enter-active {
  transition: 400ms var(--transition-cubic-bounce);
}

.open-modal-enter {
  opacity: 0;
  transform: translate(-100%, -10%);
}

.open-modal-leave-to {
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
  transform: translate(-100%, -10%);
}
</style>
